import { useState } from "react";
import Footer from "../components/Footer";

export default function Contact() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const validateEmail = (value) => {
    if (/[A-Z]/.test(value)) return false;
    const regex = /^[a-z0-9._%+-]+@(gmail\.com|outlook\.com|yahoo\.com)$/;
    return regex.test(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setIsInvalid(true);
      alert("Please enter valid email address");
      return;
    }

    if (!message.trim()) {
      alert("Please enter message");
      return;
    }

    setIsInvalid(false);
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("message", message);

      const res = await fetch("https://online-clipboard.in/api/send-mail.php", {
        method: "POST",
        body: formData,
      });

      const data = await res.text();

      if (data.includes("success")) {
        setSuccessMsg("Your message has been sent");
        setEmail("");
        setMessage("");

        setTimeout(() => {
          window.location.reload();
        }, 3000);

      } else {
        alert("Error sending mail");
      }

    } catch (error) {
      console.log(error);
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-appBg dark:bg-appDark px-6 py-4">

      <section className="flex-grow flex flex-col items-center justify-center max-w-4xl mx-auto w-full">

        {/* TITLE */}
        <h1 className="text-3xl font-bold text-center text-titleLight dark:text-titleDark mb-8">
          Contact Us
        </h1>

        {/* FORM CARD */}
        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col gap-6 bg-card dark:bg-cardDark border border-borderLight dark:border-borderDark rounded-2xl p-6 shadow-sm"
        >

          {/* Email */}
          <div>
            <label className="text-sm font-medium text-textMain dark:text-textDark">
              Email Address
            </label>

            <input
              type="text"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setIsInvalid(false);
              }}
              placeholder="Enter your email"
              className={`w-full mt-2 p-3 rounded-lg border 
              ${isInvalid
                  ? "border-error focus:ring-error"
                  : "border-borderLight dark:border-borderDark focus:ring-primary"
                }
              bg-input dark:bg-inputDark 
              text-textMain dark:text-textDark
              focus:outline-none focus:ring-2 transition-all duration-200`}
            />
          </div>

          {/* Message */}
          <div>
            <label className="text-sm font-medium text-textMain dark:text-textDark">
              Message
            </label>

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your message..."
              className="w-full mt-2 p-3 rounded-lg border border-borderLight dark:border-borderDark 
              bg-input dark:bg-inputDark 
              text-textMain dark:text-textDark h-32
              focus:outline-none focus:ring-2 focus:ring-primary resize-none"
            />
          </div>

          {/* Button */}
          <button
            type="submit"
            disabled={loading}
            className="mt-2 bg-primary hover:bg-primaryHover text-white py-3 rounded-lg font-semibold transition"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>

          {/* Success Message */}
          {successMsg && (
            <p className="text-success text-center mt-2 font-medium">
              {successMsg}
            </p>
          )}

        </form>

      </section>

      <Footer />

    </div>
  );
}